/**
 * Application entry point for the IntelliPact Admin Portal.
 *
 * Initializes the Backstage application using the new frontend system.
 *
 * @packageDocumentation
 */

import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import { createAdminPortalAppRoot } from './App';
import '@backstage/ui/css/styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(createAdminPortalAppRoot());
